import { Typography } from "@mui/material";
import DateUtils from "utils/DateUtils";

const MELILLO_LOGO_SRC = "/assets/melillo_method_image.png";

/**
 * Shared report letterhead matching Home Program (StimFormReport).
 */
function MelilloReportHeader({ title, firstName, lastName, evaluationDate, extraLine }) {
  return (
    <header className="text-center">
      <img
        src={MELILLO_LOGO_SRC}
        width={100}
        alt="Melillo Method"
      />
      <Typography variant="h1" className="mt-2">
        {title}
      </Typography>
      <Typography variant="h3" className="mt-3">
        Patient :{" "}
        <u>
          {firstName} {lastName}
        </u>
      </Typography>
      {evaluationDate && (
        <Typography variant="h3" className="mt-1">
          Evaluation :{" "}
          <u>{DateUtils.formatDateTimeToDate(evaluationDate)}</u>
        </Typography>
      )}
      {extraLine}
    </header>
  );
}

export default MelilloReportHeader;
